import React, { FC, useEffect, useState } from "react";
import { Input, Row, Col } from "antd";

const EmailInput: FC<{
  value?: string;
  onChange?: any;
  placeholder?: any;
}> = ({
  value,
  onChange,
}) => {
  const [email, setEmail] = useState<any>(value ? value : '@');

useEffect(()=>{
  console.log('email value', value);
  if(value && value.includes('@')){
    setEmail(value);
  }
}, [value])

  return (
    <div className="custom-email">
      <Input 
        className="e-name"
        value={email.split('@')[0] || ''}
        onChange={(e) => { 
          setEmail(e.target.value + '@' + email.split('@')[1])
          onChange(e.target.value + '@' + email.split('@')[1]);
        }} 
      />
      <span>@</span>
      <Input 
        value={email.split('@')[1] || ''}
        className="e-type"
        onChange={(e) => { 
          setEmail(email.split('@')[0] + '@' + e.target.value)
          onChange(email.split('@')[0] + '@' + e.target.value);
        }} 
      />
    </div>
  );
};

export default EmailInput;
